import React, { useState } from 'react';

import DismissableModal from 'components/DismissableModal';
import KeyValueTable from 'components/KeyValueTable';

import { parseLowerCamelCase } from 'services/UtilityService';
import { sendAuthenticatedAsyncRequest } from 'services/AsyncRequestService';
import { formatDateForDisplay } from '../../services/MomentUtils';

const ProtectedHealthInformation = ({ globalSwitchId, openButtonMediumSize, openButtonBlock }) => {
  const [phi, setPhi] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPhi = (globalSwitchId) => {
    if (loading !== true) {
      setLoading(true);
      sendAuthenticatedAsyncRequest(
        `/phi?globalSwitchId=${globalSwitchId}`,
        "GET",
        null,
        (r) => {
          setPhi(r.data);
          setLoading(false);
        },
        (r) => {
          setPhi(undefined);
          setLoading(false);
        }
      );
    }
  };

  const handleShow = () => {
    fetchPhi(globalSwitchId);
  };

  const handleClose = () => {
    setTimeout(() => setPhi(null), 200);
  };

  return (
    <DismissableModal
      openModalButtonText="Show PHI"
      openModalButtonStyle="outline-warning"
      openModalButtonSize={openButtonMediumSize ? '' : 'sm'}
      openModalButtonBlock={openButtonBlock}
      openModalButtonTestId='btn-member-show-phi'
      title="Protected Health Information for Patient"
      centered
      onShow={handleShow}
      onClose={handleClose}
    >
      {
        loading === true
          ? "Loading PHI ..."
          : phi === undefined
            ? "Unable to access PHI"
            : phi === null
              ? "PHI Cleared"
              : <KeyValueTable rows={
                Object.keys(phi).map(k => {
                  return parseLowerCamelCase(k) === "Date Of Birth" ?
                    ({ label: parseLowerCamelCase(k), value: formatDateForDisplay(phi[k]) }) :
                    ({ label: parseLowerCamelCase(k), value: phi[k] })
                })} />
      }
    </DismissableModal>
  );
};

export default ProtectedHealthInformation;